import React, { useState, useEffect } from "react";  // import useEffect
import { Link } from "react-router-dom";
import {Toolbar, Button, Typography, Box, TextField, Checkbox, Container, Grid} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import api, {consoleDevLog} from "../apiConfig";
import { MarketingContext } from "./MarketingContext";
import PreConPreview from "./PreConPreview";
import { useHistory } from "react-router-dom";


import "../assets/styles/PreConEmail.css";
import Breadcrumb from "./BreadcrumbsComponent";
import * as assert from "assert";

const PreConEmail = () => {
  const { marketingMaterials, addMarketingMaterials } = React.useContext(MarketingContext);
  const [selectedDivs, setSelectedDivs] = useState({});
  const [fieldValues, setFieldValues] = useState({});
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [processing, setProcessing] = useState(false);  // New state variable
  const [file, setFile] = useState(null);
  const backendDirectory = ""
  var marketingMaterial = {}
  if (marketingMaterials.length > 0) {
    marketingMaterial = marketingMaterials.find(m => m.type === "E-mail");
  }

  // Image Fields
  const [headerImageIds, setHeaderImageIds] = useState([]);
  const [featureImageIds, setFeatureImageIds] = useState([]);
  const [additionalImageIds, setAdditionalImageIds] = useState([]);
  const [floorplanImageIds, setFloorplanImageIds] = useState([]);
  const imageSetters = [setHeaderImageIds, setFeatureImageIds, setAdditionalImageIds, setFloorplanImageIds]

  //Text Fields
  const [emailTitle, setEmailTitle] = useState('');
  const [projectTagline, setProjectTagline] = useState('');
  const [projectDescription, setProjectDescription] = useState('');
  const [locationDescription, setLocationDescription] = useState('');
  const [incentivesDescription, setIncentivesDescription] = useState('');
  const [depositStructure, setDepositStructure] = useState('');
  const [showPreview, setShowPreview] = useState(false); // State to toggle preview
  const [contactInfo, setContactInfo] = useState('');
  const [additionalInfo, setAdditionalInfo] = useState('');
  const textSetters = [setEmailTitle, setProjectTagline, setProjectDescription, setLocationDescription, setIncentivesDescription, setDepositStructure, setContactInfo, setAdditionalInfo]

  const history = useHistory();

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (defaultStates[name]) {
      setDefaultStates({ ...defaultStates, [name]: false });
    }
    setFieldValues({ ...fieldValues, [name]: value });
  };

  const handleClick = (id) => {
    setSelectedDivs({ ...selectedDivs, [id]: !selectedDivs[id] });
  };

  //const headerImageIds = ['../src/assets/images/Header_1.png',];
  //const featureImageIds = ['../src/assets/images/sample_1.png', '../src/assets/images/sample_2.png'];
  //const additionalImageIds = ['../src/assets/images/Im4.jpg', '../src/assets/images/Im5.jpg', '../src/assets/images/Im6.jpg'];
  //const floorplanImageIds = ['../src/assets/images/Floorplan_1.png', '../src/assets/images/Floorplan_1.png', '../src/assets/images/Floorplan_1.png'];

  const [defaultStates, setDefaultStates] = useState({});

  const togglePreview = () => {
    setShowPreview(!showPreview);
  };

  useEffect(() => {
    // If marketingMaterials is not empty, populate the fields
    if (marketingMaterials.length > 0) {
      // Image setters
      setHeaderImageIds(marketingMaterial.headerImageIds || []);
      setFeatureImageIds(marketingMaterial.featureImageIds || []);
      setAdditionalImageIds(marketingMaterial.additionalImageIds || []);
      setFloorplanImageIds(marketingMaterial.floorplanImageIds || []);

      // Text setters
      setEmailTitle(marketingMaterial.emailTitle || '');
      setProjectTagline(marketingMaterial.projectTagline || '');
      setProjectDescription(marketingMaterial.projectDescription || '');
      setLocationDescription(marketingMaterial.locationDescription || '');
      setIncentivesDescription(marketingMaterial.incentivesDescription || '');
      setDepositStructure(marketingMaterial.depositStructure || '');
      setContactInfo(marketingMaterial.contactInfo || '');
      setAdditionalInfo(marketingMaterial.additionalInfo || '');
      setUploadedFileName("abc")
      setProcessing(false)
    }
  }, [marketingMaterials]);

  const fields = [
    { type: 'textbox', name: 'emailTitle', default: emailTitle },
    { type: 'images', name: 'headerImages', ids: headerImageIds },
    { type: 'images', name: 'featureImages', ids: featureImageIds },
    { type: 'textfield', name: 'projectTagline' , default: projectTagline},
    { type: 'textfield', name: 'projectDescription', default: projectDescription},
    { type: 'textfield', name: 'locationDescription', default: locationDescription},
    { type: 'textfield', name: 'incentivesDescription', default: incentivesDescription},
    { type: 'images', name: 'additionalImages', ids: additionalImageIds },
    { type: 'images', name: 'floorplanImages', ids: floorplanImageIds },
    { type: 'textfield', name: 'depositStructure', default: depositStructure},
    { type: 'textbox', name: 'contactInfo', default: contactInfo},
    { type: 'textfield', name: 'additionalInfo', default: additionalInfo},
  ];

  const handleCheckboxChange = (name, event) => {
    setDefaultStates({ ...defaultStates, [name]: event.target.checked });
    if (event.target.checked) {
      setFieldValues({ ...fieldValues, [name]: fields.find(f => f.name === name).default });
    } else {
      setFieldValues({ ...fieldValues, [name]: '' });
    }
  };

  const handleSubmit = async (event) => {
    const file = event.target.files[0];
    setUploadedFileName(file.name);
    setFile(file);
    if (!file) {
      alert("Please select a file first!");
      return;
    }
    const formData = new FormData();
    formData.append("zip_file", file);
    try {
      const response = await api.post("/marketing/upload", formData, {
        headers: {
            "Content-Type": file.type,
        }
      })
      const data = response.data;
      const { headerImages, featureImages, additionalImages, floorplanImages } = data.images;
      const imageLists = [headerImages, featureImages, additionalImages, floorplanImages];
      // Loop through each image list and set the state variables
      imageLists.forEach((imageList, index) => {
        imageSetters[index](imageList);
      });

      const { emailTitle, projectTagline, projectDescription, locationDescription, incentivesDescription, depositStructure, contactInfo, additionalInfo } = data.text;
      const textLists = [emailTitle, projectTagline, projectDescription, locationDescription, incentivesDescription, depositStructure, contactInfo, additionalInfo];
      // Loop through each text list and set the state variables
      textLists.forEach((textList, index) => {
          textSetters[index](textList);
      });
      setProcessing(false);
    } catch (error) {
      console.log(error)
    }
  }

  const handlePublishEmail = async () => {
    const type = "E-mail";
    const title = "Pre-Construction E-mail";
    const clientId = "651cbd2188711d875731390a";
    const realtorId = "6552b44fd56a4b6eef501e53";
    const img = "../src/assets/images/home-email.png";
    const emailData = {
        headerImageIds,
        featureImageIds,
        additionalImageIds,
        floorplanImageIds,
        emailTitle,
        projectTagline,
        projectDescription,
        locationDescription,
        incentivesDescription,
        depositStructure,
        contactInfo,
        additionalInfo,
        type,
        title,
        clientId,
        realtorId,
        img
    }
    consoleDevLog(emailData)
    addMarketingMaterials(emailData);
    try {
      const response = await api.post("/marketing/email", emailData);
      consoleDevLog(response);
    } catch (error) {
      console.log(error);
    }
    history.push("/smart-marketing");
  }

  useEffect(() => {
    let timeoutId;
    if (uploadedFileName) {
      setProcessing(true);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    }
  }, [uploadedFileName]);

  return (
    <Container>
      <Grid container spacing={3}>
        <Breadcrumb />
      </Grid>

      <div className="core-element">
      <Toolbar>
        <Button variant="contained" color="secondary" onClick={togglePreview}>
          {showPreview ? 'Return to Design' : 'Preview'}
        </Button>
        <div style={{ flex: 1 }}></div>
        <Button variant="contained" color="primary">
          Auto Generate
        </Button>
        <Button variant="contained" color="secondary" onClick={handlePublishEmail}>
          Publish
        </Button>
      </Toolbar>
        {!showPreview ? (
            <>
          <Typography variant="h4" style={{ marginTop: "16px" }}>
            Preconstruction E-mail
          </Typography>
          <Box id="uploadBox" display="flex" alignItems="center" style={{ marginTop: "16px" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CloudUploadIcon />}
              style={{ position: "relative" }}
            >
              Upload Material
              <input type="file" style={{ position: "absolute", opacity: 0, left: 0, right: 0, top: 0, bottom: 0 }} onChange={handleSubmit} />
            </Button>
            {uploadedFileName &&
              <Typography variant="body1" style={{ marginLeft: "16px" }}>
                {uploadedFileName}
              </Typography>
            }
          </Box>
          {uploadedFileName && processing &&
            <Typography variant="body1" style={{ marginTop: "16px" }}>
              Processing pre-construction package...
            </Typography>
          }
          {uploadedFileName && !processing && (
            <div className="fade-in">
              {fields.map((field) => {
                switch (field.type) {
                  case 'textbox':
                  case 'textfield':
                    return (
                      <div key={field.name}>
                        <label>
                          <Typography variant="h6" style={{ marginTop: "16px" }}>
                            {field.name.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); })}
                          </Typography>
                        </label>
                        <TextField
                          name={field.name}
                          value={fieldValues[field.name] || ''}
                          onChange={handleChange}
                          placeholder={Array.isArray(field.default) ? field.default.join(', ') : field.default}
                          fullWidth
                          margin="normal"
                          variant="outlined"
                          multiline={field.type === 'textfield'}
                        />
                        <Checkbox
                          checked={defaultStates[field.name] || false}
                          onChange={(event) => handleCheckboxChange(field.name, event)}
                          inputProps={{ 'aria-label': `Use Default Text for ${field.name}` }}
                        />
                        <label>Use Default Text for {field.name.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); })}</label>
                      </div>
                    );
                  case 'images':
                    return (
                      <div key={field.name}>
                        <Typography variant="h6" style={{ marginTop: "16px" }}>
                          {field.name.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); })}
                        </Typography>
                        <div className="box-container">
                          {field.ids.map(id => (
                            <Box
                              key={id}
                              id={id}
                              onClick={() => handleClick(id)}
                              className={`box ${selectedDivs[id] ? 'selected' : ''}`}
                              style={{ padding: "5px" }}
                            >
                              <img
                                src={`../src/assets/images/${id.split('/').pop()}`}
                                className="box-image"
                                alt="Image description"
                                style={{ maxWidth: "100%", maxHeight: "100%", display: "block" }}
                              />
                            </Box>

                          ))}
                        </div>
                      </div>
                    );
                  default:
                    return null;
                }
              })}
            </div>
          )}
        </>
        ): (
            <PreConPreview
                headerImageIds={headerImageIds}
                featureImageIds={featureImageIds}
                additionalImageIds={additionalImageIds}
                floorplanImageIds={floorplanImageIds}
                emailTitle={emailTitle}
                projectTagline={projectTagline}
                projectDescription={projectDescription}
                locationDescription={locationDescription}
                incentivesDescription={incentivesDescription}
                depositStructure={depositStructure}
                contactInfo={contactInfo}
                additionalInfo={additionalInfo}
            />
        )}



    </div>

    </Container>
  );
}

export default PreConEmail;
